export const environment = {
  production: true,

  apiBaseUrl: 'https://api-dev.bluedop.com',

  appName: 'BlueDop Medical Platform'
};